import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/**
 * Sidebar nudge that reminds signed-in users about their locked bonus CAUL
 * and the 100-CAUL-per-paid-transaction drip. Hidden when the user has no
 * remaining locked CAUL.
 */
export default function LockupNudge() {
  const { user } = useAuth();
  const [lockups, setLockups] = useState(null);

  useEffect(() => {
    if (!user) return;
    let cancelled = false;
    api
      .get("/rewards/lockups")
      .then(({ data }) => { if (!cancelled) setLockups(data); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user]);

  if (!user || !lockups || !lockups.stillLocked || lockups.stillLocked <= 0) return null;

  const total = lockups.totalLocked || 0;
  const still = lockups.stillLocked || 0;
  const pct = total > 0 ? Math.max(2, Math.min(100, Math.round(((total - still) / total) * 100))) : 0;

  return (
    <div
      className="parchment p-5 border-primary/30 bg-primary/[0.04]"
      data-testid="feed-lockup-nudge"
    >
      <div className="flex items-center gap-2 mb-2">
        <Lock size={14} className="text-primary" strokeWidth={2} />
        <span className="label-mystic text-primary">Bonus CAUL Locked</span>
      </div>
      <div className="font-serif text-2xl text-secondary leading-none mt-1" data-testid="feed-lockup-still">
        {still}
        <span className="text-foreground/40 text-sm font-sans ml-1">/ {total} CAUL</span>
      </div>
      <div className="h-1 mt-3 bg-primary/10 rounded-sm overflow-hidden">
        <div
          className="h-full bg-secondary/80"
          style={{ width: `${pct}%` }}
        />
      </div>
      <p className="text-xs text-foreground/65 mt-3 leading-relaxed">
        Your next paid transaction releases another <b className="text-secondary">100 CAUL</b> from your bonus bucket.
      </p>
      <Link
        to="/wallet"
        className="inline-block mt-3 text-secondary hover:text-secondary/80 text-xs uppercase tracking-wider"
        data-testid="feed-lockup-cta"
      >
        Unlock more →
      </Link>
    </div>
  );
}
